import { useSelector } from "react-redux";
import { RootState } from "../store";
import { getRequestedRFZORequests } from "../utils/receivableItemUtils";
import { useTabNotifications } from "../hooks/useTabNotifications";

const TabNotificationManager = () => {
  const receivedOrders = useSelector(
    (state: RootState) => state.order.receivedOrders,
  );
  const rfzoTherapyRequests = useSelector(
    (state: RootState) => state.rfzoTherapy.rfzoTherapyRequests,
  );

  const count =
    receivedOrders.length +
    getRequestedRFZORequests(rfzoTherapyRequests).length;

  useTabNotifications(count);

  return null;
};

export default TabNotificationManager;
